<template>
  <div class="text-center">
    <HeartContainer :rating="rating" class="justify-center" />
    <span class="d-block mb-4 mt-2">
      <span class="font-size-xl font-weight-bold">{{ float(rating) }} </span>
      {{ outOfHeartsLabel }}
    </span>
    <span
      class="c-black font-size-s text-uppercase l-spacing-half"
      v-html="ratingsCountLabel"
    ></span>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const HeartContainer = defineAsyncComponent(
  () => import('@/components/basic/atoms/HeartContainer.vue')
)

const MAX_HEART_RATING = 5

export default {
  components: { HeartContainer },
  props: {
    rating: [String, Number],
    ratingsCount: [String, Number]
  },
  computed: {
    outOfHeartsLabel() {
      return this.translate(
        'pdp_heart_ratings_out_of_x_hearts',
        MAX_HEART_RATING
      )
    },
    ratingsCountLabel() {
      return this.translate('pdp_confirmed_purchases', this.ratingsCount)
    }
  }
}
</script>
